<!--
  -  Copyright (c) Qwoach LLC 2022. All rights reserved.
  -  Unauthorized copying of this file, via any medium is strictly prohibited
  -  Proprietary and confidential
  -  Created by Artem Bogush <artem@qwoach.com> on 20/10/2022
  -->

<template>
	<el-collapse v-model="valueData" v-bind="listenersComputed">
		<slot></slot>
	</el-collapse>
</template>

<script>

import BaseVModelView from "@/core/components/BaseVModelView.vue";

export default {
	name: "QwCollapse",
	components: {},
	extends: BaseVModelView,
	inheritAttrs: false,


	data() {
		return {
			valueDataPrev: null,
			diffValue: null,
			isAdded: false
		}
	},

	methods: {
		calculateValueDiff() {
			if(Array.isArray(this.valueData)){
				if(!this.valueDataPrev){
					this.valueDataPrev = []
				}
				this.isAdded = this.valueData.length > this.valueDataPrev.length
				let targetArray = this.isAdded ? this.valueDataPrev : this.valueData
				let otherArray = !this.isAdded ? this.valueDataPrev : this.valueData
				let i = 0
				while(i < targetArray.length && targetArray[i] === otherArray[i]){
					i++
				}
				this.diffValue = otherArray[i]
				this.valueDataPrev = this.valueData
			}
		}
	},

	computed: {
		listenersComputed() {
			delete this.$attrs.onChange
			return {
				...this.$attrs,
				onChange: () => {
					this.calculateValueDiff()
					// console.log("QwCollapse change: diffValue = ", this.diffValue, ", isAdded = ", this.isAdded, ", this.valueData = ", this.valueData)
					let verb = this.isAdded ? " expanded" : " collapsed"
					let name = this.diffValue + verb
					this.trackEvent(name)
					this.notifyValueChanged()
				}
			}
		}
	},
}
</script>

<style lang="scss">

</style>
